import Details from "~/components/parking/Details"
import Savings from "~/components/parking/Savings"
import Checkout from "~/components/parking/Checkout"
import Success from "~/components/parking/Success"
import STYLE_CONSTANTS from '~/style/constants'


const EVIDENCE = {
  order: 0,
  slug: "evidence",
  Component: Details,
  // this self is the flow store
  validate: async self => {
    return true
  }
}

const SAVINGS = {
  order: 1,
  slug: "savings",
  Component: Savings,
  // this self is the flow store
  validate: async self => {
    return true
  }
}

const PAYMENT = {
  order: 2,
  slug: "payment",
  Component: Checkout,
  // this self is the flow store
  validate: async self => {
    return true
  }
}

const SUCCESS = {
  order: 3,
  slug: "success",
  Component: Success,
  progressBarColor: STYLE_CONSTANTS.colors.primary.green,
  // this self is the flow store
  validate: async self => {
    return true
  }
}

const FIGHT_STEPS = [EVIDENCE, SAVINGS, PAYMENT, SUCCESS]

export default FIGHT_STEPS
